import { render, staticRenderFns } from "./ProjectDocumentsPage.vue?vue&type=template&id=1558d260&scoped=true"
import script from "./ProjectDocumentsPage.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentsPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocumentsPage.vue?vue&type=style&index=0&id=1558d260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1558d260",
  null
  
)

export default component.exports